import React from 'react';

export const packagesReportListColumns = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'نام بسته',
    dataIndex: 'name',
    name: 'name',
    isSortable: false,
  },
  {
    title: 'تعداد بسته خریداری شده',
    dataIndex: 'totalBoughtPackages',
    name: 'totalBoughtPackages',
    isSortable: false,
  },
  {
    title: 'تعداد کل آرسی',
    dataIndex: 'totalBoughtRsee',
    name: 'totalBoughtRsee',
    isSortable: false,
  },
  {
    title: 'مبلغ پرداخت شده بابت خرید بسته',
    dataIndex: 'totalPaidPrice',
    name: 'totalPaidPrice',
    isSortable: false,
    render: amount => (
      <div className={`direction-ltr`}>{Number(amount).toLocaleString()}</div>
    ),
  },
];